import React from "react";
import Photo1 from "../images/orchard.jpeg";

function Orchard() {
  return (
    <div className="orchard">
      <div className="container scroll">
        {/* Header Section */}
        <section className="hero-section text-center">
          <h1>Chinbrook Community Orchard</h1>
        </section>

        {/* Orchard Description Section */}
        <section className="orchard-description">
          <div className="text-center">
            <img
              src={Photo1}
              alt="orchard"
              className="orchard-photo img-fluid rounded shadow mb-4"
              style={{
                maxWidth: "70%",
                borderRadius: "15px",
                boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                margin: "0 auto",
                display: "block",
              }}
            />{" "}
            <p
              style={{
                fontSize: "0.85rem",
                color: "#6c757d",
                marginTop: "0.25rem",
              }}
            >
              © Victoria Morris
            </p>
          </div>
          <p>
            Planted in 1991 by Lewisham’s Nature Conservation Team, the orchard
            is designated a Grade II Site of Borough Importance for Nature
            Conservation. Most of the trees are traditional Kentish varieties,
            including cobnuts, plums, pears, cherries, walnuts, and over 30
            varieties of apples, with poetic names such as ‘Kentish Filbasket’,
            ‘Beauty of Kent’, ‘Decio’, and ‘Allington Pippin’. A few more exotic
            species, including cork oak, olives, walnuts, and stone pines, were
            also planted to reflect the borough’s ethnic diversity, alongside a
            small demonstration vineyard.
          </p>
          <p>
            The grass between the fruit trees is managed as a hay meadow, cut
            rotationally each year to provide habitat for wood mice, common
            lizards, slow worms, and a variety of invertebrates, including stag
            beetles, which benefit from the dead wood structures in the orchard.
            Ant hills are scattered throughout the grassland, and the uncommon
            grass vetchling grows here in profusion. Two allotment plot holders
            currently maintain beehives in the orchard.
          </p>
          <p>
            At the orchard’s edge, two ponds planted with native marginal and
            aquatic plants support breeding populations of common frogs, common
            toads, and smooth newts, which feed in the surrounding tall
            grassland.
          </p>
          <p>
            Day-to-day management of the orchard is carried out for the London
            Borough of Lewisham by a dedicated group of allotment plot holders,
            with oversight from an Orchard Sub-committee reporting to the
            Allotment Committee.
          </p>
          <p>
            The orchard was awarded a London in Bloom Gold Biodiversity award in
            2024 and 2025, recognising its contribution to local wildlife and
            biodiversity.
          </p>
        </section>

        {/* Contact Section */}
        <section className="contact">
          <h2 className="font-weight-bold">Contact</h2>
          <p>
            Access to the orchard is restricted to site key holders. For further
            information or to arrange a visit, contact the Orchard sub-committee
            by email at{" "}
            <a
              href="mailto:ccorchard@outlook.com"
              target="_blank"
              rel="noreferrer"
              className="text-primary"
            >
              ccorchard@outlook.com
            </a>
            .
          </p>
        </section>
      </div>
    </div>
  );
}

export default Orchard;
